<template>
  <div id="app">
	<router-view></router-view>
  </div>
</template>

<script>
export default {
  name:'App',
  created() {
	  let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
	  console.log(userInfo)
	  if(userInfo != null && userInfo != undefined){
		  this.$post('/blade-auth/oauth/token' + '?grant_type=refresh_token&tenantId=000000&refresh_token=' + userInfo.refresh_token,{})
		  .then((res) => {
		  	console.log(res);
		  	if(res.access_token){
					//保存用户信息
					this.$store.dispatch('userLogin',res)
		  	}else{
		  		this.$store.dispatch('userLogout')
		  	}
		  })
	  }
  }
}
</script>

<style>
html body{
	margin: 0;padding: 0;display: flex;justify-content: center;
}
#app{
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue